import { FC } from 'react';

import { SwimlaneItem } from '../../forces/assetDetails/assetDetails.types';

import { StackedProviderImage } from './StackedProviderImage';

export const ProviderImageWrapper: FC<{
  logos: SwimlaneItem['logos'];
  width?: string | number;
  portrait?: boolean;
}> = ({ logos, width, portrait = false }) => {
  return <StackedProviderImage width={width} variants={logos} portrait={portrait} />;
};
